import {Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[cclPermission]'
})
export class PermissionDirective implements OnChanges {
    @Input()
    cclPermission = '';

    @Input()
    cclPermissionRule = '';

    @Input()
    cclPermissionParam = {};

    private hasView = false;

    constructor(private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef) {
    }

    private viewRef(code) {
        let isPermission = false;
        try {
            isPermission = Function('param', 'return ' + code)(this.cclPermissionParam);
        } catch (e) {
        }
        if (!isPermission) {// æ æé
            this.viewContainer.clear();
            this.hasView = false;
        } else if (!this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.cclPermissionRule) {
            this.findPermission(this.cclPermissionRule);
        }
        if (this.cclPermission) {
            this.findPermission(this.cclPermission);
        }
    }

    private async findPermission(code) {
        code = String(code || '').trim();
        if (code && PermissionService.$data) {
            const result = await PermissionService.$data;

            const data = result.code === 0 ? result.data : result;

            // æ¿æ¢ææå¯æ¾å°çæéä¸º boolean
            Object.keys(data).forEach(key => code = code.replace(key, data[key]));

            // æ¿æ¢æææªè½æ¾å°çæéä¸º false
            code = code.replace(/([\w-]+:?)+/g, a => a.includes(':') ? 'false' : a);

            this.viewRef(code);
        }
    }
}

export class PermissionService {
    static $data: Promise<any> = Promise.resolve({});
}
